export const TOAST_LEVEL = {
	INFO: 'Info',
	ERROR: 'Error',
	SUCCESS: 'Success',
	WARNING: 'Warning',
};
